// dependency-graph-ignore-file
import { type Database } from '@databases/model/database';

import { getValueId } from '../utils/collab-utils.ts';

export function deleteField(ydb: Database, fieldId: string): void {
  ydb.mutate((db) => {
    db.deleteField(fieldId);

    db.views.forEach((viewId: string) => {
      db.viewsById[viewId].removeFieldVisibilityField(fieldId, db.fields);
      db.viewsById[viewId].removeCalculation(fieldId);
      db.viewsById[viewId].sorts.deleteSortForFieldId(fieldId);
    });

    Object.keys(db.entriesById).forEach((entryId) => {
      db.entriesById[entryId].removeValue(fieldId);
    });

    db.entries.forEach((entryId) => {
      const valueId = getValueId(entryId, fieldId);

      if (valueId in db.commentThreads) {
        db.removeCommentsOnValue(valueId);
      }
    });
  });
}
